import React, { useContext, useState } from 'react';

import './FencerDetail.css';
import '../../styles/colors.css';

import localize from '../../i18n/localize';
import LocalizedContext from '../../i18n/LocalizedContext';
import { makeBoutList } from '../opponent/Opponent';

const FencerDetail = props => {
    const fencer = props.fencer;
    const details = props.details;
    const addNoteHandler = props.addNoteHandler;
    const removeNoteHandler = props.removeNoteHandler;

    const lang = useContext(LocalizedContext);

    const [editNotes, setEditNotes] = useState(false);
    const [note, setNote] = useState('');

    const submitNoteHandler = () => {
        addNoteHandler(fencer, note);
        setEditNotes(false);
        setNote('');
    };

    const elos = details.elo.map( (elo, index) => {
        const event = elo.eventType;
        const ctw = elo.elo;

        return (
            <div key={index}>
                <div className='FencerDetail-ctw'>
                    {localize(lang, event.organization)} {localize(lang, event.age)} {localize(lang, event.weapon)}: {ctw ? `${ctw}%` : 'N/A'}
                </div>
            </div>); 
    });

    const notes = details.notes.map( (note, index) => {
        const notesWithLines = note.note.split('\n').map((line, i) => (
            <React.Fragment key={i}>
                {line}
                <br />
            </React.Fragment>
        ));

        const currentDay = new Date().toISOString().split('T')[0];
        const canDelete = note.created === currentDay ? 
            <span className='FencerDetail' onClick={ () => removeNoteHandler(fencer, note.id) }>X</span>
             : '';

        return (
            <tr key={index}>
                <td className='FencerDetail'>{note.created}</td>
                <td className='FencerDetail'>{notesWithLines}</td>
                <td className='FencerDetail'>{canDelete}</td>
            </tr>);
    });

    const notesTable = notes.length > 0 ?
        <table className='FencerDetail'>
            <tbody>
                {notes}
            </tbody>
        </table> : '';

    const addNotes = editNotes ?
        <div>
            <textarea 
                style={{ width: '80%', backgroundColor: '#FFF695', margin: '20px' }}
                rows={6}
                onChange={(e) => setNote(e.target.value)}
            />
            <br/>
            <span className='FencerDetail' onClick={ () => submitNoteHandler() }>{localize(lang, 'submitNote')}</span>
        </div> : '';

    const results = Object.keys(details.results).map( (eventType, index) => {
        let displayName;
        switch(eventType) {
            case 'individual':
                displayName = localize(lang, 'individualResults');
                break;
            case 'team':
                displayName = localize(lang, 'teamResults');
                break;
            case 'teamMember':
                displayName = localize(lang, 'teamMemberResults');
                break;
            default:
                displayName = '';
        }
        
        return makeBoutList(details.results[eventType], displayName, index);
    });

    return (
        <div>
            <div  className='FencerDetail-envelope'>
                <div  className='FencerDetail-header'>
                    {fencer} - CTW
                </div>
                <div className='FencerDetail-description'>
                    {localize(lang, 'ctwExplanation')}
                </div>
                {elos}
            </div>
            <div  className='FencerDetail-envelope'>
                <div  className='FencerDetail-header'>
                    {fencer} - {localize(lang, 'boutResults')}
                </div>
                {results}
            </div>
            <div  className='FencerDetail-envelope'>
                <div  className='FencerDetail-header'>
                    {fencer} - {localize(lang, 'notes')}:
                </div>
                <div className='FencerDetail-description'>
                    <span className='FencerDetail' onClick={ () => setEditNotes(!editNotes) }>{localize(lang, 'addNote')}</span>
                    {addNotes}
                    {notesTable}
                </div>
            </div>
        </div> );
}

export default FencerDetail;